<div class="new-ec-member-container">
    <mat-horizontal-stepper [disableRipple]="true" (selectionChange)="selectionChange($event)" [linear]="true" #stepper>
        <ng-template matStepperIcon="edit" let-index="index">{{ index + 1 }}</ng-template>
        <!-- STEP1 Biographical data -->
        <mat-step [completed]="form1.valid || (form1.dirty && isUpdate)">
            <ng-template matStepLabel>
                <span class="title">{{ 'Biographical data'|i18n }}</span>
            </ng-template>
            <div class="container p-30 mt-32" fxLayout="column">
                <form [formGroup]="form1" fxLayout="column">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" class="mb-30">
                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                            {{ ('How participate in the community'|i18n) + ':*' }}
                        </div>
                        <ng-container *ngIf="!isUpdate">
                            <div fxFlex app-input-container>
                                <mat-select app-small-select [placeholder]="'Participation type'|i18n"
                                            formControlName="participationType"
                                            (selectionChange)="detectSelectChanges($event)">
                                    <mat-option *ngFor="let participationType of participationTypes"
                                                [value]="participationType">
                                        {{ participationType|genericPipe }}
                                    </mat-option>
                                </mat-select>
                            </div>
                            <div *ngIf="!this.form1.controls.participationType.pristine && this.form1.controls.participationType.invalid"
                                 app-error>
                                {{ 'Invalid type'|i18n }}
                            </div>
                        </ng-container>
                        <ng-container *ngIf="isUpdate">
                            <div>{{ participationType|genericPipe }}</div>
                        </ng-container>
                        <div fxFlex="20"></div>
                    </div>
                    <ng-container *ngIf="isUpdate && !isNotInvited">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" class="mb-30">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Access to'|i18n) + ':' }}</div>
                            <div>{{ (getAccessType + '__{table}')|i18n }}</div>
                            <div fxFlex="20"></div>
                        </div>
                    </ng-container>
                    <div class="main-title w-30" fxLayout="row" fxLayoutAlign="end">
                        {{ 'Biographical data'|i18n }}
                    </div>
                    <div fxLayout="column" fxLayoutGap="24px" class="form mt-32">
                        <div fxLayout="row" fxLayoutAlign="start center"
                             fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Juridical type'|i18n) + ':*' }}</div>
                            <ng-container *ngIf="!isUpdate">
                                <div fxFlex app-input-container>
                                    <mat-select app-small-select
                                                [placeholder]="'Juridical type'|i18n"
                                                formControlName="juridicalType">
                                        <mat-option *ngFor="let juridicalType of JURIDICAL_TYPES" [value]="juridicalType">
                                            {{ juridicalType|ecMemberJuridicalType|i18n }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                                <div *ngIf="!this.form1.controls.juridicalType.pristine && this.form1.controls.juridicalType.invalid"
                                     app-error>
                                    {{ 'Invalid type'|i18n }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="isUpdate">
                                <div>{{ juridicalType|ecMemberJuridicalType|i18n }}</div>
                            </ng-container>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px"
                             *ngIf="form1.controls.juridicalType.value === ECJuridicalType.INDIVIDUAL">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Legal form type'|i18n) + ':*' }}</div>
                            <ng-container *ngIf="!isUpdate">
                                <div fxFlex app-input-container class="max-width-43-5">
                                    <mat-select app-small-select
                                                [placeholder]="'Legal form'|i18n"
                                                formControlName="legalForm">
                                        <mat-option *ngFor="let legalFormType of LEGAL_FORM_TYPES" [value]="legalFormType">
                                            {{ legalFormType|ecMemberLegalFormType|i18n }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                                <div *ngIf="!this.form1.controls.legalForm.pristine && this.form1.controls.legalForm.invalid"
                                     app-error>
                                    {{ 'Invalid type'|i18n }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="isUpdate">
                                <div>{{ legalFormType|ecMemberLegalFormType|i18n }}</div>
                            </ng-container>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px"
                             *ngIf="form1.controls.juridicalType.value === ECJuridicalType.CORPORATE_ENTITY">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Subject type'|i18n) + ':*' }}</div>
                            <ng-container *ngIf="!isUpdate">
                                <div fxFlex app-input-container class="max-width-43-5">
                                    <mat-select app-small-select
                                                [placeholder]="'Subject type'|i18n"
                                                formControlName="subjectType">
                                        <mat-option *ngFor="let subjectType of SUBJECT_TYPES" [value]="subjectType">
                                            {{ subjectType|ecMemberSubjectType|i18n }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="isUpdate">
                                <div>{{ subjectType|ecMemberSubjectType|i18n }}</div>
                            </ng-container>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px"
                             *ngIf="form1.controls.subjectType.value === ECSubjectType.TERRITORIAL_BODY_LOCAL_AUTHORITY_OTHER_BODY">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Entity subtype'|i18n) + ':' }}</div>
                            <ng-container *ngIf="!isUpdate || !member.member.entity_subtype">
                                <div fxFlex app-input-container class="max-width-43-5">
                                    <mat-select app-small-select
                                                [placeholder]="'Entity subtype'|i18n"
                                                formControlName="entitySubtype">
                                        <mat-option *ngFor="let entitySubtype of ENTITY_SUBTYPES" [value]="entitySubtype">
                                            {{ entitySubtype|ecMemberEntitySubtype|i18n }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                                <div *ngIf="!this.form1.controls.entitySubtype.pristine && this.form1.controls.entitySubtype.invalid"
                                     app-error>
                                    {{ 'Invalid type'|i18n }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="isUpdate && member.member.entity_subtype">
                                <div>{{ entitySubtype|ecMemberEntitySubtype|i18n }}</div>
                            </ng-container>
                            <div fxFlex="20"></div>
                        </div>
                        <div *ngIf="isCompany" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Business name'|i18n) + ':*' }}
                            </div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="companyName">
                                <div *ngIf="invalidCompanyName" app-error>{{ 'Invalid business name'|i18n }}</div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Name'|i18n) + ':*' }}</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="firstName">
                                <div *ngIf="invalidFirstName" app-error>{{ 'Invalid name'|i18n }}</div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Last name'|i18n) + ':*' }}</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="lastName">
                                <div *ngIf="invalidLastName" app-error>{{ 'Invalid last name'|i18n }}</div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ 'Email'|i18n }}:</div>
                            <div fxFlex app-input-container
                                 *ngIf="!isUpdate || isUpdate && !ecMember.personal_data.email">
                                <input app-input formControlName="email">
                                <ng-container *ngIf="invalidEmail">
                                    <div *ngIf="uniqueEmailError" app-error>{{ 'E-mail already exists'|i18n }}</div>
                                    <div *ngIf="!uniqueEmailError" app-error>{{ 'Invalid email'|i18n }}</div>
                                </ng-container>
                            </div>
                            <div *ngIf="isUpdate && ecMember.personal_data.email">
                                {{ ecMember.personal_data.email }}
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px"
                             *ngIf="!isUpdate || isUpdate && !ecMember.personal_data.email">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ 'Confirm email'|i18n }}:</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="confirmEmail" (paste)="false" (copy)="false" (cut)="false">
                                <ng-container *ngIf="invalidConfirmEmail">
                                    <div *ngIf="notMatchingEmails" app-error>{{ 'E-mails do not match'|i18n }}</div>
                                    <div *ngIf="!notMatchingEmails" app-error>{{ 'Invalid email'|i18n }}</div>
                                </ng-container>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">{{ 'Mobile'|i18n }}:</div>
                            <div *ngIf="!isUpdate || isUpdate && !ecMember.personal_data.mobile_number" fxFlex app-input-container>
                                <input app-input formControlName="mobileNumber" [maxLength]="MOBILE_MAX_CHARS">
                                <div *ngIf="invalidMobileNumber" app-error>{{ 'Invalid mobile number'|i18n }}</div>
                            </div>
                            <div *ngIf="isUpdate && ecMember.personal_data.mobile_number">
                                {{ ecMember.personal_data.mobile_number }}
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div *ngIf="!isCompany" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">{{ 'Fiscal code'|i18n }}:</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="fiscalCode" [maxLength]="TAX_ID_MAX_CHARS">
                                <div *ngIf="isControlOK(form1, 'fiscalCode')" app-error>{{ 'Invalid fiscal code'|i18n }}</div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div *ngIf="isCompany" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">{{ 'VAT number'|i18n }}
                                :
                            </div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="vatNumber" [maxLength]="VAT_NUMBER_MAX_CHARS">
                                <div *ngIf="isControlOK(form1, 'vatNumber')" app-error>{{ 'Invalid VAT number'|i18n }}</div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">{{ 'IBAN'|i18n }}:</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="iban" [maxLength]="IBAN_MAX_CHARS">
                                <div *ngIf="isControlOK(form1, 'iban')" app-error>{{ 'Invalid IBAN'|i18n }}</div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div app-divider class="divider"></div>
                        <div class="main-title w-30" fxLayout="row" fxLayoutAlign="end">
                            {{ 'Address'|i18n }}
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">
                                {{ ((juridicalType === ECJuridicalType.CORPORATE_ENTITY ? 'Registered office address' : 'Residential address')|i18n) + ':*' }}
                            </div>
                            <div fxFlex>
                                <app-google-maps-address-autocomplete [formControlRef]="addressFormControl"
                                                                      [requiresGooglePlace]="false"
                                                                      (addressChange)="addressChange($event)">
                                </app-google-maps-address-autocomplete>
                            </div>
                            <div fxFlex="20"></div>
                        </div>

                        <div app-divider class="divider"></div>
                        <div class="main-title w-30" fxLayout="row" fxLayoutAlign="end">
                            {{ 'Contacts'|i18n }}
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30"
                                 class="t-right">{{ 'Phone number'|i18n }}:
                            </div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="phoneNumber" [maxLength]="MOBILE_MAX_CHARS">
                                <div *ngIf="isControlOK(form1, 'phoneNumber')" app-error>{{ 'Invalid phone number'|i18n }}
                                </div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">{{ 'PEC'|i18n }}:</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="pec" [maxLength]="EMAIL_MAX_CHARS">
                                <div *ngIf="isControlOK(form1, 'pec')" app-error>{{ 'Invalid PEC'|i18n }}</div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                    </div>
                    <div app-divider class="divider"></div>
                    <ng-container formArrayName="documents" class="mb-20">
                        <ng-container *ngFor="let documentForm of documentControls; let i = index">
                            <div class="lesson-form-row mt-25" [formGroup]="documentForm" fxLayout="column"
                                 fxLayoutGap="15px">
                                <div class="main-title w-30" fxLayout="row" fxLayoutAlign="end">
                                    {{ 'Document {0}'|i18n:i + 1 }}
                                </div>
                                <div fxLayout="column" fxLayoutGap="4px">
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30"
                                             class="t-right">{{ ('Document type'|i18n) + ':*' }}
                                        </div>
                                        <div fxFlex>
                                            <mat-select app-small-select formControlName="type"
                                                        placeholder="{{'Document type'|i18n}}" fxFlex>
                                                <mat-option *ngFor="let documentType of documentTypes|async"
                                                            [value]="documentType">
                                                    <div>{{ documentType|ecDocumentTypeI18n }}</div>
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                        <div fxFlex="20"></div>
                                    </div>

                                    <div *ngIf="getControl(documentForm,'type').value === EC_DOCUMENT_TYPE_OTHER"
                                         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                        <div fxFlex="30"></div>
                                        <div fxLayout="column" fxFlex>
                                            <div fxFlex app-input-container>
                                                <input #input app-input
                                                       [formControl]="getControl(documentForm,'customType')"
                                                       [maxLength]="NAME_MAX_CHARS"
                                                       [placeholder]="'Document type'|i18n">
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                                <mat-hint class="txt-s-12-4">
                                                    {{ 'Max {0} characters'|i18n:NAME_MAX_CHARS }}
                                                </mat-hint>
                                                <mat-hint class="txt-s-12-4">
                                                    {{ input.value.length }}
                                                    / {{ NAME_MAX_CHARS }} {{ 'characters'|i18n }}
                                                </mat-hint>
                                            </div>
                                            <div *ngIf="!documentForm.controls.customType.valid && documentForm.controls.customType.dirty"
                                                 class="invalid-doc" app-error>
                                                {{ 'Invalid document type'|i18n }}
                                            </div>
                                        </div>
                                        <div fxFlex="20"></div>
                                    </div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                    <div fxLayout="row" fxLayoutAlign="end"
                                         fxFlex="30">{{ ('Upload document'|i18n) + ':*' }}
                                    </div>
                                    <div *appVar="uploadedFileName(documentForm) as fileName"
                                         fxFlex="35" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                        <input #fileSelect type="file" style="display: none"
                                               [accept]="ACCEPTED_MIME_TYPES"
                                               (change)="onUploadDocumentFile(documentForm, $event)">
                                        <button app-small-primary-button (click)="fileSelect.click()">
                                            {{ (fileName ? 'Change file' : 'Upload file')|i18n }}
                                        </button>
                                        <div *ngIf="fileName">{{ fileName }}</div>
                                        <div *ngIf="hasDocFileError(documentForm)"
                                             app-error>{{ 'No file uploaded'|i18n }}
                                        </div>
                                    </div>
                                    <div fxFlex="20">
                                        <button app-icon-button class="app-button-alert"
                                                [title]="'Remove document'|i18n"
                                                (click)="onClickRemoveDocument(i,documentForm)">
                                            <app-icon name="fal-trash-alt"></app-icon>
                                        </button>
                                    </div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                    <div fxFlex="30">
                                    </div>
                                    <div fxFlex>
                                        <span class="txt-s-14-4">{{ '(Max {0} MB. Accepts only {1}.)'|i18n:MAX_FILE_MB:mimeTypesNames }}</span>
                                    </div>
                                    <div fxFlex="20"></div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <div fxLayout="row" fxLayoutAlign="center"
                         [ngClass]="{'mt-12': !documentControls.length, 'mt-32': !!documentControls.length}">
                        <button app-small-ghost-button (click)="onClickAddDocument()">
                            <app-icon name="fal-plus-square"></app-icon>
                            {{ (documentControls.length ? 'Add another document' : 'Add a document')|i18n }}
                        </button>
                    </div>
                </form>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
                <div fxFlex>
                    <button app-ghost-button (click)="cancel()">
                        <app-icon class="app-icon-right" name="fal-times"></app-icon>
                        {{ 'Cancel'|i18n }}
                    </button>
                </div>
                <div fxFlex>&nbsp;</div>
                <div>
                    <button app-primary-button matStepperNext [disabled]="!form1.valid || (!form1.dirty && !isUpdate)
                        || continueDisabled">
                        {{ 'Continue'|i18n }}
                        &nbsp;<app-icon class="app-icon-right" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
            </div>
        </mat-step>
        <!-- STEP2 POD data -->
        <mat-step [completed]="isStep2Valid">
            <ng-template matStepLabel>
                <span class="title">{{ 'POD data'|i18n }}</span>
            </ng-template>
            <form [formGroup]="form2" fxLayout="column">
                <ng-container formArrayName="pods">
                    <ng-container *ngFor="let podForm of podControls; let i = index">
                        <div fxLayout="column" fxLayoutGap="24px" class="form p-30 mt-32 container"
                             [formGroup]="podForm">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="main-title">
                                    {{ 'POD ' + (i + 1) }}
                                </div>
                                <div fxFlex app-input-container *ngIf="podControls.length > 1">
                                    <button app-icon-button class="app-button-alert pull-right"
                                            [title]="'Remove Pod'|i18n"
                                            (click)="onClickRemovePod(i)">
                                        <app-icon name="fal-trash-alt"></app-icon>
                                    </button>
                                </div>
                                <div fxFlex="20"></div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">POD:*</div>
                                <div fxFlex="30" app-input-container>
                                    <input app-input
                                           formControlName="podCode"
                                           [maxLength]="POD_MAX_CHARS"
                                           [readOnly]="isPersistentPod(podForm)">
                                    <div *ngIf="podError(podForm) === 'pod'" app-error>
                                        {{ 'Invalid POD'|i18n }}
                                    </div>
                                    <div *ngIf="podError(podForm) === 'unique_pod' || hasExistingResource(podForm)" app-error>
                                        {{ 'POD already existing'|i18n }}
                                    </div>
                                    <div *ngIf="isProducerResource(podForm) && isThirdPartyProducer && podError(podForm) === 'pod_has_capital_grant'"
                                         app-error>
                                        {{ 'Enter a new POD or producer POD without a configured capital grant'|i18n }}
                                    </div>
                                    <div *ngIf="podError(podForm) === 'pod_profile'" app-error>
                                        {{ 'POD profile unspecified'|i18n }}
                                    </div>
                                    <ng-container *ngIf="!podError(podForm) && !!podEntity(podForm)">
                                        <ng-container *ngIf="isProducerResource(podForm)">
                                            <div *ngIf="(isThirdPartyProducer || !isMobileMember)" app-hint>
                                                {{ 'POD matches resource {0}'|i18n:podEntity(podForm).name }}
                                            </div>
                                            <div *ngIf="isMobileMember" app-error>
                                                {{ 'Enter a new POD or consumer/prosumer POD'|i18n }}
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="!isProducerResource(podForm)">
                                            <div *ngIf="isThirdPartyProducer" app-error>
                                                {{ 'Enter a new POD or producer POD'|i18n }}
                                            </div>
                                            <div *ngIf="!isThirdPartyProducer" app-hint>
                                                {{ 'POD matches resource {0}'|i18n:podEntity(podForm).name }}
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <app-icon name="fas-info-circle"
                                          [title]="('14 or 15 digit alphanumeric code'|i18n) + '\n' + ('Example: IT001E123456789'|i18n)"></app-icon>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxLayout="row" fxLayoutAlign="end"
                                     fxFlex="30">{{ ('Consumer address'|i18n) + ':*' }}
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start"
                                     fxFlex="50">
                                    <mat-slide-toggle app-toggle formControlName="podAddressLikeMember"
                                                      class="txt-p-16-4 mr-22">
                                    </mat-slide-toggle>
                                    {{ 'Same address of residence/office'|i18n }}
                                </div>
                                <div fxFlex="20"></div>
                            </div>
                            <div fxLayout="column" fxLayoutGap="20px">
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">
                                        &nbsp;
                                    </div>
                                    <div fxFlex *ngIf="podAddressFormControl(podForm).enabled">
                                        <app-google-maps-address-autocomplete [formControlRef]="podAddressFormControl(podForm)"
                                                                              (addressChange)="addressPodChange($event, podForm)">
                                        </app-google-maps-address-autocomplete>
                                    </div>
                                    <div fxFlex *ngIf="podAddressFormControl(podForm).disabled" app-input-container>
                                        <input app-input [formControl]="podAddressFormControl(podForm)">
                                    </div>
                                    <div fxFlex="20"></div>
                                </div>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Wi-Fi'|i18n) + ':' }}</div>
                                <mat-slide-toggle app-toggle formControlName="hasWifi" class="txt-p-16-4 mr-22">
                                </mat-slide-toggle>
                            </div>


                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30"
                                     class="t-right">{{ ('Energy supplier'|i18n) + ':' }}
                                </div>
                                <div fxFlex app-input-container>
                                    <input class="input-font" app-input formControlName="podProvider"
                                           [maxLength]="DEFAULT_MAX_CHARS">
                                    <div *ngIf="invalidPodProvider(podForm)"
                                         app-error>{{ 'Invalid POD supplier'|i18n }}
                                    </div>
                                </div>
                                <div fxFlex="20"></div>
                            </div>

                            <div *appVar="podHasActivationDate(podForm) as podHasApprovalDate" fxLayout="row"
                                 fxLayoutAlign="start center" fxLayoutGap="30px" class="override-mb">
                                <div fxLayout="row wrap" fxLayoutAlign="end" fxFlex="30" class="t-right">
                                    {{ ('Activation date'|i18n) + ':' }}
                                </div>
                                <div *ngIf="podHasApprovalDate" fxLayout="row" fxLayoutAlign="space-between center"
                                     fxFlex="40"
                                     app-input-container>
                                    <div fxLayout="column">
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                            <input app-input
                                                   [matDatepicker]="podActivationDate"
                                                   [min]="communityActivationDate"
                                                   [disabled]="isUpdate"
                                                   formControlName="podActivationDate">
                                            <mat-datepicker-toggle [for]="podActivationDate"></mat-datepicker-toggle>
                                            <mat-datepicker #podActivationDate></mat-datepicker>
                                        </div>
                                        <div *ngIf="podError(podForm) === 'bad_date'" app-error>
                                            {{ 'Invalid date'|i18n }}
                                        </div>
                                    </div>
                                    <button *ngIf="isUpdate ? canResetActivationDate(podForm) : true" app-ghost-button
                                            (click)="onClickResetPodActivationDate(podForm)">
                                        <app-icon name="fal-calendar-alt"></app-icon>
                                        {{ 'Reset date'|i18n }}
                                    </button>
                                </div>
                                <div *ngIf="!podHasApprovalDate" fxFlex="20">
                                    <button app-ghost-button
                                            (click)="onClickSetPodActivationDate(podForm)"
                                            [disabled]="isCommunityActivationDateEmpty">
                                        <app-icon name="fal-calendar-alt"></app-icon>
                                        {{ 'Insert date'|i18n }}
                                    </button>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxFlex="30"></div>
                                <div fxLayout="row" fxFlex fxLayoutAlign="center center" fxLayoutGap="20px"
                                     class="info-panel">
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        <app-icon class="fix-icon" name="fas-info-circle"></app-icon>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="start start">
                                        <div class="txt-p-14-4 fix-text">
                                            {{ 'GSE defined date.'|i18n }} {{ 'Energy data and incentives will be accounted for from this date.' |i18n }} {{ !podHasActivationDate(podForm) ? ('It is not eligible for inclusion if the community has no activation date'|i18n) + '.' : '' }}
                                        </div>
                                    </div>
                                </div>
                                <div fxFlex="20"></div>
                            </div>

                            <div *ngIf="isUpdate">
                                <div *appVar="podHasDeactivationDate(podForm) as hasDeactivationDate"
                                     fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">
                                        {{ ('Deactivation date'|i18n) + ':' }}
                                    </div>
                                    <div *ngIf="hasDeactivationDate" fxLayout="row" fxLayoutAlign="start center"
                                         fxLayoutGap="10px"
                                         fxFlex="40" app-input-container>
                                        <div fxLayout="column">
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                                <input class="input-font" app-input
                                                       [matDatepicker]="deactivationDatePicker"
                                                       [min]="podMinDeactivationDate(podForm)"
                                                       [disabled]="hasDeactivationDate"
                                                       formControlName="podDeactivationDate">
                                                <mat-datepicker-toggle
                                                        [for]="deactivationDatePicker"></mat-datepicker-toggle>
                                                <mat-datepicker #deactivationDatePicker></mat-datepicker>
                                            </div>
                                            <div *ngIf="podDeactivationDateHasError(podForm)" app-error class="mt-40">
                                                {{ 'Invalid date'|i18n }}
                                            </div>
                                            <div *ngIf="podHasError(podForm, 'date_mismatch')" app-error class="mt-40">
                                                {{ 'GSE deactivation date must follow GSE approval date'|i18n }}
                                            </div>
                                        </div>
                                        <button *ngIf="!isDeactivationDateSetInStone(podForm)" app-ghost-button
                                                (click)="onClickResetPodDeactivationDate(podForm)">
                                            <app-icon name="fal-calendar-alt"></app-icon>
                                            {{ 'Reset date'|i18n }}
                                        </button>
                                        <ng-container *ngTemplateOutlet="iconTooltip"></ng-container>
                                    </div>
                                    <div *ngIf="!hasDeactivationDate" fxFlex="20" fxLayout="row" fxLayoutGap="10px"
                                         fxLayoutAlign="start center">
                                        <button app-ghost-button (click)="onClickSetDeactivationDate(podForm)"
                                                [disabled]="!podHasActivationDate(podForm)">
                                            <app-icon name="fal-power-off"></app-icon>
                                            {{ 'Insert date'|i18n }}
                                        </button>
                                        <ng-container *ngTemplateOutlet="iconTooltip"></ng-container>
                                    </div>
                                    <div fxFlex="20"></div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <div fxLayout="row" fxLayoutAlign="center"
                     [ngClass]="{'mt-12': !podControls.length, 'mt-32': !!podControls.length}">
                    <button app-small-ghost-button (click)="onClickAddPod()">
                        <app-icon name="fal-plus-square"></app-icon>
                        {{ (podControls.length ? 'Add another POD' : 'Add a pod')|i18n }}
                    </button>
                </div>
            </form>
            <div *ngIf="showInvitingForm && !step3Enabled">
                <ng-container *ngTemplateOutlet="invitationFrom"></ng-container>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
                <div fxFlex>
                    <button app-ghost-button matStepperPrevious>
                        <app-icon class="app-icon-right" name="fal-arrow-left"></app-icon>
                        {{ 'Back'|i18n }}
                    </button>
                </div>
                <div fxFlex>&nbsp;</div>
                <div *ngIf="step3Enabled">
                    <button app-primary-button [disabled]="!isStep2Valid" (click)="goToStep3(stepper)">
                        {{ 'Continue'|i18n }}
                        &nbsp;<app-icon class="app-icon-right" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
                <div *ngIf="!step3Enabled">
                    <button app-primary-button [disabled]="!isStep2Valid"
                            (click)="save()">
                        {{ 'Save'|i18n }}
                        &nbsp;<app-icon class="app-icon-right" name="fal-check-circle"></app-icon>
                    </button>
                </div>
            </div>
        </mat-step>
        <!-- STEP3 Energy data -->
        <mat-step [completed]="!(!form2.valid || (!form2.dirty && !isUpdate))" *ngIf="!isUpdate || step3Enabled">
            <ng-template matStepLabel>
                <span class="title">{{ 'Energy data'|i18n }}</span>
            </ng-template>
            <form [formGroup]="form2" fxLayout="column">
                <ng-container formArrayName="pods">
                    <ng-container *ngFor="let podForm of podControls; let i = index">
                        <div *ngIf="!hasEntity(podForm) && !isPersistentPod(podForm)"
                             fxLayout="column" fxLayoutGap="24px" class="form mt-32 container p-30"
                             [formGroup]="podForm">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30"
                                     class="main-title">{{ 'POD' }}{{ podForm.controls.podCode.value ? (': ' + podForm.controls.podCode.value) : (i + 1) }}
                                </div>
                            </div>
                            <!-- Energy profile -->
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                                    {{ ('Energy profile'|i18n) + ':*' }}
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start" fxFlex="40">
                                    <mat-radio-group class="set-gap" formControlName="podEnergyProfile" fxLayout="row"
                                                     fxLayoutGap="35px" color="primary">
                                        <mat-radio-button app-radio-button *ngFor="let podType of POD_TYPES"
                                                          [disabled]="podType.id !== PodEnergyProfiles.PRODUCER && isThirdPartyProducer || podType.id === PodEnergyProfiles.PRODUCER && isMobileMember"
                                                          [value]="podType.id" class="txt-p-16-4">
                                            {{ podType.label|i18n }}
                                            <app-icon
                                                    *ngIf="podType.id === PodEnergyProfiles.PRODUCER && isMobileMember"
                                                    class="ml-10 txt-p-16-4" name="fas-info-circle"
                                                    [title]="'You cannot set the energy profile of this POD as a producer because of a member accessing the mobile app.'|i18n"></app-icon>
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <div fxFlex="20"></div>
                            </div>
                            <div *ngIf="isThirdPartyProducer" fxLayout="row" fxLayoutAlign="start center">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30"></div>
                                <div fxLayout="row" fxLayoutAlign="start" fxFlex class="ml-30">
                                    <div fxLayout="row" fxLayoutAlign="center center"
                                         fxLayoutGap="20px" class="info-panel">
                                        <app-icon icon-color-h name="fas-info-circle"></app-icon>
                                        <div>{{ 'This POD belongs to a third-party producer. Its energy profile cannot be different from producer.'|i18n }}</div>
                                    </div>
                                </div>
                                <div fxFlex="20"></div>
                            </div>
                            <!-- Utility type -->
                            <!-- mandatory only if podEnergyProfile !== PRODUCER -->
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                                    {{ ('Utility type'|i18n) + ':' + (podEnergyProfile(podForm) !== PodEnergyProfiles.PRODUCER ? '*' : '') }}
                                </div>
                                <mat-select app-small-select class="mr-12"
                                            [disabled]="isPersistentPod(podForm) || podEnergyProfile(podForm) === PodEnergyProfiles.PRODUCER"
                                            formControlName="podUtilityType" placeholder="{{'Type of utility'|i18n}}"
                                            fxFlex>
                                    <mat-option
                                            *ngFor="let utilityType of getPodUtilityTypes(juridicalType, legalFormType, subjectType, entitySubtype)"
                                            [value]="utilityType">
                                        <div>{{ utilityType|genericPipe }}</div>
                                    </mat-option>
                                </mat-select>
                                <div *ngIf="aspiringProsumerForForm(podForm)" fxFlex>
                                    <button app-small-ghost-button
                                            fxLayoutAlign="space-around center" fxLayoutGap="6px"
                                            (click)="removeAspiringProsumer(podForm)" class="grey-btn"
                                            [matTooltip]="'Delete tag'|i18n">
                                        <app-icon name="fal-telescope"></app-icon>
                                        <div class="field-comm">{{ 'Aspiring prosumer'|i18n }}</div>
                                        <div class="grey-box">
                                            <app-icon class="no-margin grey-icon" name="fal-times"></app-icon>
                                        </div>
                                    </button>
                                </div>
                                <div *ngIf="!this.form1.controls.juridicalType.pristine && this.form1.controls.juridicalType.invalid"
                                     app-error>
                                    {{ 'Invalid type'|i18n }}
                                </div>
                                <div fxFlex="20"></div>
                            </div>
                            <!-- Voltage connection -->
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ 'Voltage connection'|i18n }}:*
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start" fxFlex="50">
                                    <mat-radio-group class="set-gap" formControlName="podVoltage"
                                                     fxLayout.gt-xs="row wrap" fxLayoutGap.gt-xs="35px"
                                                     fxLayoutGap.xs="15px" color="primary">
                                        <mat-radio-button app-radio-button *ngFor="let pv of POD_VOLTAGES"
                                                          name="podVoltage"
                                                          [value]="pv.value" class="txt-p-16-4">
                                            {{ pv.name|i18n }}
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <div fxFlex="20"></div>
                            </div>
                            <!-- Phases -->
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ 'Phases'|i18n }}:*
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start" fxFlex="50">
                                    <mat-radio-group class="set-gap" formControlName="podPhase"
                                                     fxLayout.gt-xs="row wrap"
                                                     fxLayoutGap.gt-xs="35px" fxLayoutGap.xs="15px" color="primary">
                                        <mat-radio-button app-radio-button *ngFor="let pp of POD_PHASES"
                                                          [value]="pp.value">
                                            {{ pp.name|i18n }}
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <div fxFlex="20"></div>
                            </div>
                            <!-- Contractual power -->
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ 'Contractual power'|i18n }}:
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start">
                                    <mat-select app-small-select formControlName="contractualPower"
                                                placeholder="{{'Contractual power'|i18n}}">
                                        <mat-option *ngFor="let cp of contractualPowerValues" [value]="cp.value">
                                            <div>{{ cp.name }}</div>
                                        </mat-option>
                                    </mat-select>
                                </div>
                                <div fxFlex="20"></div>
                            </div>
                            <!-- plants -->
                            <ng-container formArrayName="plants">
                                <ng-container *ngFor="let plantForm of plantControls(podForm); let j = index">
                                    <div app-divider class="divider"></div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="mt-20">
                                        <div fxLayout="row" fxFlex="30" fxLayoutAlign="end"
                                             class="sub-title">{{ ('Plant data' |i18n) + ': ' + getFormControl(plantForm, 'plantName').value }}
                                        </div>
                                        <div fxFlex="10" *ngIf="plantControls(podForm).length > 1">
                                            <div fxLayout="row" fxLayoutAlign="end" [ngClass]="'w-50'">
                                                <button app-icon-button class="app-button-alert pull-right"
                                                        [title]="'Remove plant'|i18n"
                                                        (click)="onClickRemovePlant(podForm,j)">
                                                    <app-icon name="fal-trash-alt"></app-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Name'|i18n) + ':*' }}
                                        </div>
                                        <div>{{ getFormControl(plantForm, 'plantName').value }}</div>
                                        <div fxFlex="20"></div>
                                    </div>
                                    <div fxLayoutAlign="start center" fxLayoutGap="30px">
                                        <div fxLayout="row" fxLayoutAlign.gt-xs="end" fxFlex="30"
                                             [ngClass.xs]="'w-100'">{{ 'Production POD'|i18n }}:
                                        </div>
                                        <div fxFlex app-input-container>
                                            <input app-input
                                                   [formControl]="getFormControl(plantForm,'podCode')"
                                                   [maxLength]="POD_MAX_CHARS">
                                            <div *ngIf="plantPodError(plantForm) === 'pod'" app-error>
                                                {{ 'Invalid POD'|i18n }}
                                            </div>
                                            <div *ngIf="plantPodError(plantForm) === 'unique_pod'" app-error>
                                                {{ 'POD already existing'|i18n }}
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="start">
                                            <app-icon name="fas-info-circle"
                                                      [title]="('14 or 15 digit alphanumeric code, example: ITP0AE123456789'|i18n)">
                                            </app-icon>
                                        </div>
                                        <div fxFlex="20"></div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ 'Type'|i18n }}:*
                                        </div>
                                        <div fxFlex fxLayoutAlign="start">
                                            <mat-select app-small-select
                                                        [formControl]="getFormControl(plantForm,'plantType')"
                                                        placeholder="{{ 'Type of plant'|i18n }}">
                                                <mat-option *ngFor="let plant of PLANT_TYPES" [value]="plant">
                                                    <div>{{ plant.name|i18n }}</div>
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                        <div fxFlex="20"></div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                                            {{ ('Nominal power'|i18n) + ':*' }}
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="10px">
                                            <div fxFlex app-input-container>
                                                <input class="input-font"
                                                       app-input
                                                       type="number"
                                                       step="0.01"
                                                       [formControl]="getFormControl(plantForm,'nominalPower')"
                                                       (input)="limitDecimals(plantForm,'nominalPower')">
                                                <div *ngIf="isPlantControlOK(plantForm, 'nominalPower')" app-error>
                                                    {{ 'Invalid value'|i18n }}
                                                </div>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center">kW</div>
                                        </div>
                                        <div fxFlex="20"></div>
                                    </div>
                                    <div *ngIf="!isThirdPartyProducer" fxLayout="column" fxLayoutGap="20px">
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                                                {{ ('Capital grant'|i18n) + (getFormControl(plantForm, 'capitalGrant').disabled ? ':' : ':*') }}
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                <div fxFlex app-input-container>
                                                    <input class="input-font"
                                                           app-input
                                                           type="number"
                                                           [disabled]="plantForm.controls.capitalGrant.disabled"
                                                           [formControl]="getFormControl(plantForm,'capitalGrant')"
                                                           (input)="limitDecimals(plantForm,'capitalGrant')">
                                                    <div *ngIf="isPlantControlOK(plantForm, 'capitalGrant') && plantForm.controls.capitalGrant.enabled"
                                                         app-error>
                                                        {{ 'Invalid value'|i18n }}
                                                    </div>
                                                </div>
                                                <div fxLayout="row" fxLayoutAlign="start center">%</div>
                                                <app-icon name="fas-info-circle"
                                                          [title]="getFormControl(plantForm,'capitalGrant').enabled ?
                                                          ('Percentage of public funding given to the member or community for expenses incurred in the construction of a renewable plant, up to a maximum of 40%. Its use results in a reduction of the incentive fee by up to 50% in proportion to the percentage of contribution received.'|i18n) :
                                                          ('To configure capital grant the plant effective date must be same as or later than {0}'|i18n:(UPPER_INCENTIVE_BOUNDARY|i18nDate))">
                                                </app-icon>
                                            </div>
                                            <div fxFlex="20"></div>
                                        </div>
                                        <div *ngIf="getFormControl(plantForm,'capitalGrant').enabled"
                                             fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                            <div fxFlex="30"></div>
                                            <div fxLayout="row" fxLayoutAlign="start center" class="txt-s-12-7">
                                                {{ 'From {0} to {1}'|i18n:0:40 }}%
                                            </div>
                                        </div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px"
                                         class="override-mb">
                                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                                            {{ 'Effective date'|i18n }}:
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                                             class="w-100">
                                            <div fxLayout="row" fxLayoutAlign="start center" app-input-container
                                                 class="w-100" fxLayoutGap="10px">
                                                <ng-container *ngIf="hasDate(plantForm)">
                                                    <div fxLayout="column">
                                                        <div app-input-container fxLayout="row"
                                                             fxLayoutAlign="start center" fxLayoutGap="4px">
                                                            <input app-input [matDatepicker]="effectiveDatePicker"
                                                                   [formControl]="getFormControl(plantForm,'enterData')">
                                                            <mat-datepicker #effectiveDatePicker></mat-datepicker>
                                                            <div *ngIf="getPlantDateError(plantForm) === 'bad_date'"
                                                                 app-error>
                                                                {{ 'Invalid date'|i18n }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button app-ghost-button (click)="onClickResetPlantDate(plantForm)">
                                                        <app-icon name="fal-calendar-alt"></app-icon>
                                                        {{ 'Reset date'|i18n }}
                                                    </button>
                                                </ng-container>
                                                <button *ngIf="!hasDate(plantForm)" app-ghost-button
                                                        (click)="onClickSetPlantDate(plantForm)">
                                                    <app-icon name="fal-calendar-alt"></app-icon>
                                                    {{ 'Insert date'|i18n }}
                                                </button>
                                            </div>
                                        </div>
                                        <div fxFlex="20"></div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30"></div>
                                        <div fxLayout="row" fxLayoutAlign="end" fxFlex>
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                                                 class="w-100">
                                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                                                     class="info-panel">
                                                    <div fxLayout="row" fxLayoutAlign="start center">
                                                        <app-icon class="fix-icon" name="fas-info-circle"></app-icon>
                                                    </div>
                                                    <div fxLayout="column" fxLayoutAlign="start start">
                                                        <div class="txt-p-14-4 fix-text">{{ 'Without this date, the economic input data will be incomplete.'|i18n }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div fxFlex="20"></div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                        <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                                            {{ 'Incentive mode'|i18n }}:
                                        </div>
                                        <div fxFlex fxLayoutAlign="start" *appVar="getIncentiveTypes(plantForm) as plantIncentiveTypes">
                                            <mat-select app-small-select
                                                        [disabled]="!hasDate(plantForm) || plantIncentiveTypes[1]"
                                                        [formControl]="getFormControl(plantForm,'incentiveType')"
                                                        placeholder="{{'Incentive mode'|i18n}}">
                                                <mat-option *ngFor="let it of plantIncentiveTypes[0]" [value]="it">
                                                    <div>{{ it|genericPipe|i18n }}</div>
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                        <div fxFlex="20"></div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="center center" class="w-100">
                                        <app-wizard-pod-card [formControl]="getFormControl(plantForm,'profile')"
                                                             [mode]="WizardPodCardMode.STATISTICAL_PROFILE"
                                                             [resource]="mkStatisticalProfilePlantResource(plantForm)"
                                                             [resetValueProvider]="mkPlantStatisticalProfileResetValueProvider(plantForm)"
                                                             [isRequired]="plantForm.controls.plantType.value === WIND_PLANT_TYPE"
                                                             [ngClass.gt-xs]="'w-85'" [ngClass.xs]="'w-100'">
                                        </app-wizard-pod-card>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="center center" class="w-100">
                                        <app-wizard-pod-card [formControl]="getFormControl(plantForm,'predictiveModel')"
                                                             [mode]="WizardPodCardMode.PREDICTIVE_MODEL"
                                                             [resource]="mkPredictiveModelPlantResource(plantForm)"
                                                             [resetValueProvider]="mkPlantPredictiveModelResetValueProvider(plantForm)"
                                                             [ngClass.gt-xs]="'w-85'" [ngClass.xs]="'w-100'">
                                        </app-wizard-pod-card>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <!-- Add another plant -->
                            <div fxLayout="row" fxLayoutAlign="center center" *ngIf="plantControls(podForm).length"
                                 class="mt-30 mb-30">
                                <button app-ghost-button
                                        class="fix-button"
                                        (click)="onClickAddPlant(podForm)">
                                    <app-icon name="fal-plus-square"></app-icon>
                                    <span>{{ 'Add another plant'|i18n }}</span>
                                </button>
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="24px" class="form mt-32 p-30 container"
                             [formGroup]="podForm"
                             *ngIf="hasEntity(podForm) || isPersistentPod(podForm)">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30"
                                     class="main-title">{{ 'POD' }}{{ podForm.controls.podCode.value ? (': ' + podForm.controls.podCode.value) : (i + 1) }}
                                </div>
                            </div>
                            <!-- Utility type -->
                            <!-- mandatory only for producer member or third party producer -->
                            <div *ngIf="!isProducerResource(podForm)"
                                 fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                                    {{ ('Utility type'|i18n) + ':*' }}
                                </div>
                                <mat-select app-small-select class="mr-12" [disabled]="isPersistentPod(podForm)"
                                            formControlName="podUtilityType" placeholder="{{'Type of utility'|i18n}}"
                                            fxFlex>
                                    <mat-option
                                            *ngFor="let utilityType of getPodUtilityTypes(juridicalType, legalFormType, subjectType, entitySubtype)"
                                            [value]="utilityType">
                                        <div>{{ utilityType|genericPipe }}</div>
                                    </mat-option>
                                </mat-select>
                                <div *ngIf="aspiringProsumerForForm(podForm)" fxFlex>
                                    <button app-small-ghost-button
                                            fxLayoutAlign="space-around center" fxLayoutGap="6px"
                                            (click)="removeAspiringProsumer(podForm)" class="grey-btn"
                                            [matTooltip]="'Delete tag'|i18n">
                                        <app-icon name="fal-telescope"></app-icon>
                                        <div class="field-comm">{{ 'Aspiring prosumer'|i18n }}</div>
                                        <div class="grey-box">
                                            <app-icon class="no-margin grey-icon" name="fal-times"></app-icon>
                                        </div>
                                    </button>
                                </div>
                                <div *ngIf="!this.form1.controls.juridicalType.pristine && this.form1.controls.juridicalType.invalid"
                                     app-error>
                                    {{ 'Invalid type'|i18n }}
                                </div>
                                <div fxFlex="20"></div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="mt-10">
                                <div fxLayout="row" fxLayoutAlign="center center" fxFlex>
                                    <span>{{ 'This utility will be associated with the energy resource:' |i18n }}</span>&nbsp;
                                    <span><strong>{{ podForm.controls.entityName.value }}</strong></span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </form>
            <div *ngIf="showInvitingForm && !step4Enabled">
                <ng-container *ngTemplateOutlet="invitationFrom"></ng-container>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
                <div fxFlex>
                    <button app-ghost-button matStepperPrevious>
                        <app-icon class="app-icon-right" name="fal-arrow-left"></app-icon>
                        {{ 'Back'|i18n }}
                    </button>
                </div>
                <div fxFlex>&nbsp;</div>
                <div *ngIf="step4Enabled">
                    <button app-primary-button [disabled]="!form2.valid || (!form2.dirty && !isUpdate) || step3Busy"
                            (click)="goToStep4(stepper)">
                        {{ 'Continue'|i18n }}
                        &nbsp;<app-icon class="app-icon-right" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
                <div *ngIf="!step4Enabled">
                    <button app-primary-button [disabled]="!form2.valid || (!form2.dirty && !isUpdate) || step3Busy"
                            (click)="save()">
                        {{ 'Save'|i18n }}
                        &nbsp;<app-icon class="app-icon-right" name="fal-check-circle"></app-icon>
                    </button>
                </div>
            </div>
        </mat-step>
        <!-- STEP4 Statistical profile -->
        <mat-step [completed]="!(!form2.valid || (!form2.dirty && !isUpdate))" *ngIf="step4Enabled">
            <ng-template matStepLabel>
                <span class="title">{{ 'Statistical profile'|i18n }}</span>
            </ng-template>
            <form [formGroup]="form2" fxLayout="column">
                <ng-container formArrayName="pods">
                    <ng-container *ngFor="let podForm of podControls; let i = index">
                        <div fxLayout="column" fxLayoutGap="24px" class="form p-30 mt-32 container"
                             [formGroup]="podForm"
                             *ngIf="!hasEntity(podForm) && !isPersistentPod(podForm)">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30"
                                     class="main-title">{{ 'POD' }}{{ podForm.controls.podCode.value ? (': ' + podForm.controls.podCode.value) : (i + 1) }}
                                </div>
                            </div>
                            <div fxLayout="column" fxLayoutGap="10px" class="container"
                                 [ngClass.gt-xs]="'pr-80 pl-80'" [ngClass.xs]="'p-20'">
                                <app-wizard-pod-card *ngIf="podEnergyProfile(podForm) !== PodEnergyProfiles.PRODUCER"
                                                     class="'w-100'"
                                                     formControlName="profile"
                                                     [mode]="WizardPodCardMode.STATISTICAL_PROFILE"
                                                     [resource]="mkStatisticalProfilePodResource(podForm)"
                                                     [resetValueProvider]="mkPodStatisticalProfileResetValueProvider()"
                                                     [isRequired]="false">
                                </app-wizard-pod-card>
                                <div fxLayout="row" fxFlex fxLayoutAlign="center center" fxLayoutGap="20px">
                                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                                         class="info-panel w-60">
                                        <div fxLayout="row" fxLayoutAlign="start center">
                                            <app-icon class="fix-icon" name="fas-info-circle"></app-icon>
                                        </div>
                                        <div fxLayout="column" fxLayoutAlign="start start">
                                            <div class="txt-p-14-4 fix-text">
                                                {{ 'It will be configured through member registration'|i18n }}.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="podEnergyProfile(podForm) === PodEnergyProfiles.PRODUCER" fxLayout="row"
                                     fxLayoutAlign="center center" fxLayoutGap="20px" class="info-panel">
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        <app-icon name="fas-info-circle"></app-icon>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="start start">
                                        <div>{{ ('As a producer, the statistical profile of this POD is derived from that of its facilities'|i18n) + '.' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </form>
            <div *ngIf="showInvitingForm">
                <ng-container *ngTemplateOutlet="invitationFrom"></ng-container>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
                <div fxFlex>
                    <button app-ghost-button matStepperPrevious>
                        <app-icon class="app-icon-right" name="fal-arrow-left"></app-icon>
                        {{ 'Back'|i18n }}
                    </button>
                </div>
                <div fxFlex>&nbsp;</div>
                <div>
                    <button app-primary-button [disabled]="!form2.valid || (!form2.dirty && !isUpdate)"
                            (click)="save()">
                        {{ 'Save'|i18n }}
                        &nbsp;<app-icon class="app-icon-right" name="fal-check-circle"></app-icon>
                    </button>
                </div>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>

<ng-template #invitationFrom>
    <!-- OLD FORM moved on last tab-->
    <div fxLayout="column" class="mt-52">
        <div *ngIf="!isPending || isNotInvited" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px"
             class="mb-30">
            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Access to'|i18n) + ':' }}</div>
            <div fxFlex app-input-container>
                <mat-select app-small-select
                            [placeholder]="'Access type'|i18n"
                            [formControl]="accessTypeFormControl">
                    <mat-option *ngFor="let accessType of accessTypes" [value]="accessType">
                        {{ (accessType) + '__{table}'|i18n }}
                    </mat-option>
                </mat-select>
            </div>
            <div fxFlex="20"></div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
            <div fxFlex="22"></div>
            <div *ngIf="!enableInvitationInput" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                 class="info-panel mt-20">
                <app-icon class="fix-icon" name="fas-info-circle"></app-icon>&nbsp;
                <span class="txt-p-14-4 fix-text">
                    {{ ('Enter email and cell phone to invite member to register'|i18n) + '.' }}
                </span>
            </div>
            <div fxFlex="22"></div>
        </div>
        <!-- send invitation checkbox -->
        <div [formGroup]="form1" fxLayout="row" fxLayoutAlign="center center" class="mt-20">
            <div>
                <mat-checkbox app-checkbox formControlName="sendInvitation" class="mr-16"
                              [disabled]="!enableInvitationInput || !getAccessType"></mat-checkbox>
            </div>
            <div>{{ 'Send invitation to register'|i18n }}</div>
        </div>
    </div>
</ng-template>

<ng-template #setEffectiveDate let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 txt-a-18-7">
        {{ 'Warning: you will not be able to modify the inserted date'|i18n }}
    </div>
    <div class="light-background">
        <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
            {{ 'Declare activation date of POD validated by GSE.'|i18n }}
        </div>
        <app-activation-date
                [minDate]="data.minDate"
                [timeZone]="data.timeZone"
                (activationDate)="data.activationDate=$event"
        ></app-activation-date>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'Cancel'|i18n }}
        </button>
        <button app-primary-button [disabled]="!data.activationDate" (click)="close(data.activationDate)">
            {{ 'Confirm date'|i18n }}
        </button>
    </div>
</ng-template>


<ng-template #setPlantDate let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 txt-a-18-7">
        {{ 'Warning: you will not be able to modify the inserted date'|i18n }}
    </div>
    <div class="light-background">
        <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
            {{ 'Enter the date the system was connected to the grid'|i18n }}.
        </div>
        <app-activation-date
                [timeZone]="data.timeZone"
                [setDefaultDate]="true"
                (activationDate)="data.activationDate=$event">
        </app-activation-date>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'Cancel'|i18n }}
        </button>
        <button app-primary-button [disabled]="!data.activationDate" (click)="close(data.activationDate)">
            {{ 'Confirm date'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #deletePod let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="txt-a-18-7">
        {{ 'Warning: this action cannot be undone'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-36">
        {{ 'Are you sure you want to exclude the POD {0} of {1} from the community?'|i18n:data.pod:data.memberName }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-20">
        {{ 'The exclusion of the POD will take immediate effect after the member is updated.'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-32">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="delete-pod-warning">
            <app-icon name="fas-info-circle" class="warning-icon"></app-icon>
            <div>{{ 'By deleting a POD, you also delete the associated resource.'|i18n }}</div>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'No, cancel'|i18n }}
        </button>
        <button app-primary-button (click)="close(true)">
            {{ 'Yes, confirm'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>

<ng-template #adviceDialog let-close="close">
    <div [style.width]="window.innerWidth*0.9+'px'" fxLayout="column" class="advice-dialog text-center"
         fxLayoutAlign="center center" fxLayoutGap="55px">
        <span class="txt-h-24-7">{{ 'Energy resources were created corresponding to the PODs created'|i18n }}</span>
        <span class="txt-p-16-4" [ngClass.xs]="'w-100'" [ngClass.gt-xs]="'w-60'">
            {{ ('If smart meters with the same POD code result, they are automatically connected to POD resources'|i18n) + '.' }}
        </span>
        <button app-primary-button (click)="close()" class="w-10">
            {{ 'Ok' }}
        </button>
    </div>
</ng-template>

<ng-template #setDeactivationDate let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 txt-a-18-7">
        {{ 'Warning: you will not be able to modify the inserted date'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
        {{ 'Declare deactivation date of POD {0} of {1} validated by GSE.'|i18n:(data.pod || ''):data.memberName }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px" class="mt-40 mb-40">
        <div fxFlex="50" class="t-right">{{ ('Deactivation date__{modal}'|i18n) + ':*' }}</div>
        <div fxFlex="25" app-input-container>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                <input app-input [matDatepicker]="podDeactivationDate"
                       [min]="data.minDate"
                       [formControl]="data.date">
                <mat-datepicker-toggle matSuffix [for]="podDeactivationDate"></mat-datepicker-toggle>
                <mat-datepicker #podDeactivationDate></mat-datepicker>
            </div>
            <div *ngIf="data.date.invalid" app-error>
                {{ 'Invalid date'|i18n }}
            </div>
        </div>
        <div fxFlex="25"></div>
    </div>
    <div class="pod-deactivation-date-panel" fxLayout="row" fxLayoutAlign="center">
        <div fxLayout="row" fxLayoutGap="23px" class="ml-42 mr-42 warning-panel">
            <app-icon icon-color-w name="fas-info-circle"></app-icon>
            <div>
                <div>
                    {{ 'By declaring the deactivation of this POD, it will no longer be counted in the incentive redistribution.'|i18n }}
                </div>
                <div class="mt-20">
                    {{ 'The data history for this POD will be kept anyway.'|i18n }}
                </div>
            </div>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'Cancel'|i18n }}
        </button>
        <button app-primary-button [disabled]="data.date.invalid" (click)="close(data.date.value)">
            {{ 'Confirm date'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #iconTooltip>
    <app-icon name="fas-info-circle" [title]="('GSE defined date.'|i18n) +
                                       '\n' + ('Starting from this date, the POD will no more benefit from incentive redistribution.'|i18n)"></app-icon>
</ng-template>
